// ORDER_MORTGAGE_INSURANCE / CHECK_MORTGAGE_INSURANCE_STATUS / ACTIVATE_MORTGAGE_INSURANCE loan actions.
// All three carry an optional ProviderKey (null = the company's preferred MI provider); Order also carries
// an optional ApplicationType (null = Delegated) and a Resubmission flag, sent only when set, so an
// unchecked row stays an original order. The provider key round-trips as the raw
// string so a saved action keeps its provider even when the Integration Studio provider list is not
// loaded (the list is gated on integrations.view).

import { LoanEditorActionsEnum } from 'constants/loanActionEditor';
import { miApplicationTypeOptions } from 'constants/options';

export const getMortgageInsuranceApiFormat = (formItem, common) => {
  const item = formItem.mortgageInsurance ?? {};
  const isOrder = common.type === LoanEditorActionsEnum.ORDER_MORTGAGE_INSURANCE;

  return {
    ...common,
    providerKey: item.providerKey || null,
    ...(isOrder
      ? {
          applicationType: item.applicationType?.value ?? null,
          ...(item.resubmission ? { resubmission: true } : {}),
        }
      : {}),
  };
};

export const getMortgageInsuranceFormFormat = (actionItem, itemType, timedSequenceOptions) => ({
  itemType,
  timedSequenceOptions,
  mortgageInsurance: {
    providerKey: actionItem.providerKey ?? null,
    applicationType:
      miApplicationTypeOptions.find(({ value }) => value === actionItem.applicationType) ?? null,
    resubmission: actionItem.resubmission === true,
  },
});
